<template>
  <div class="card bg-light border-0">
    <div class="card-body py-2 text-center">
      <svg class="bi-slash-circle-fill opacity-2 mb-1" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.646-2.646a.5.5 0 0 0-.708-.708l-6 6a.5.5 0 0 0 .708.708z" />
      </svg>
      <p class="text-center text-muted mb-0 opacity-5">No available times</p>
    </div>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "NoTimes",
};
</script>
